import {
  Check,
  CircleDashed,
  CircleDot,
  CircleDotDashed,
  X,
} from "lucide-react";

export enum EvidenceStatusIcon {
  CircleDashed = "CircleDashed",
  CircleDotDashed = "CircleDotDashed",
  CircleDot = "CircleDot",
  Check = "Check",
  X = "X",
}

export const EVIDENCE_STATUS_ICONS = {
  [EvidenceStatusIcon.CircleDashed]: CircleDashed,
  [EvidenceStatusIcon.CircleDotDashed]: CircleDotDashed,
  [EvidenceStatusIcon.CircleDot]: CircleDot,
  [EvidenceStatusIcon.Check]: Check,
  [EvidenceStatusIcon.X]: X,
};

export type EvidenceStatus = {
  status_id: number;
  status_name: string;
  created_on: string;
  updated_on: string;
  uuid: string;
  color: string;
  icon: EvidenceStatusIcon;
};

export type GetEvidenceStatusQuery = {
  id: number | null;
};

export type GetEvidenceStatusResponse = {
  data: EvidenceStatus[];
};

export type GetEvidenceStatusFn = (
  options?: GetEvidenceStatusQuery
) => Promise<GetEvidenceStatusResponse>;
